import ProductCard from "./ProductCard";
import React from "react";

export default function AllProductIndividu(){
    return(
        <div className='container-alur'>
            <h2 className='text-header'>Produk Pinjaman Individu</h2>
            <div className='all-product'>
                {/* <ProductCard
                    type='individu'
                    product='kasbon'
                    title='Kasbon <em>(Emergency Loan)</em>'
                    description='Fasilitas pinjaman untuk kebutuhan darurat yang memberi kemudahan bagi karyawan seperti pembayaran gaji di muka <em>(Salary Advance).</em>' />
                 */}
                <ProductCard
                    type='individu'
                    product='pinjaman-karyawan'
                    title='Employee Benefit Program'
                    description='Fasilitas pinjaman tanpa agunan untuk berbagai macam kebutuhan. Jangka waktu pinjaman hingga 2 tahun dan pembayaran angsuran dilakukan setiap bulan.'
                />
                <ProductCard
                    type='individu'
                    product='kmg'
                    title='Kredit Multiguna'
                    description='Fasilitas pinjaman dengan jaminan tanah dan bangunan yang dapat digunakan secara fleksibel untuk berbagai macam keperluan'
                />
                {/*<ProductCard*/}
                {/*    type='individu'*/}
                {/*    product='kta'*/}
                {/*    title='Kredit Tanpa Angunan'*/}
                {/*    description='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'*/}
                {/*/>*/}
                {/*<ProductCard*/}
                {/*    type='individu'*/}
                {/*    product='pembelian-barang'*/}
                {/*    title='Kredit Pembelian Barang'*/}
                {/*    description='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'*/}
                {/*/>*/}
                {/*<ProductCard*/}
                {/*    type='individu'*/}
                {/*    product='kredit-kendaraan'*/}
                {/*    title='Kredit Kendaraan Bermotor'*/}
                {/*    description='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'*/}
                {/*/>*/}
            </div>
        </div>
    );
}